import { createSlice } from '@reduxjs/toolkit';
import SyncStorage from '@global/storage';

export const LANGUAGE_STORAGE_KEY = 'soc_lang';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', enabled: true },
  { code: 'id', label: 'Bahasa Indonesia', enabled: true },
  { code: 'ms', label: 'Bahasa Melayu', enabled: false },
  { code: 'vi', label: 'Tiếng Việt', enabled: false },
];

export const VISIBLE_LANGUAGES = SUPPORTED_LANGUAGES.filter(
  (lang) => lang.enabled,
);

const slice = createSlice({
  name: 'language',
  initialState: {
    selected: 'en',
  },
  reducers: {
    setLanguage: (state, action) => {
      state.selected = action.payload;
    },
  },
});

export const { setLanguage } = slice.actions;

export const changeLanguage = (code) => (dispatch) => {
  dispatch(setLanguage(code));
  SyncStorage.set(LANGUAGE_STORAGE_KEY, code);
};

export default slice.reducer;
